import { render } from "./MealPlannerExplanation.vue?vue&type=template&id=c366c544&scoped=true"
import script from "./MealPlannerExplanation.vue?vue&type=script&lang=js"
export * from "./MealPlannerExplanation.vue?vue&type=script&lang=js"

import "./MealPlannerExplanation.vue?vue&type=style&index=0&id=c366c544&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c366c544"]])

export default __exports__